import React from 'react';
import { IProps } from './index.types';
import { RowStyle } from './index.styled';

const RowStyled: React.FC<IProps> = ({ spaceBetween, children }) => {
  return <RowStyle spaceBetween={spaceBetween}>{children}</RowStyle>;
};

export default RowStyled;
